import React from "react";
import DashboardLayout from "../DashboardLayout";
import PlacementsContent from "../../../../components/PlacementsContent";
import EnquiriesContent from "../../../../components/EnquiriesContent";

function Placements({ user }) {
  return (
    <DashboardLayout user={user}>
      <PlacementsContent />
      <div style={{ marginTop: "1.5rem" }}>
        <EnquiriesContent />
      </div>
    </DashboardLayout>
  );
}

export default Placements;
